import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { UsersService } from '../../services/users/users.service';
import { Subscription, Subject } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.scss']
})
export class ListUserComponent implements OnInit, OnDestroy {
  
  public user_list: any;
  private subs: Array<Subscription> = [];
  private modalContent: any;
  private modalConfig: any = {
    ariaLabelledBy: 'modal-basic'
  };

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any> = new Subject();

  public editIsSuccess = false;
  public deleteIsSuccess = false;
  public selectedType: string;
  public userId: string;
  public total: number = 0;
  public page = 1;
  public limit: number = 10;
  public offset: number = 0;
  dtElement: any;
  textSearch:any;

  public area = '';
  public profile:any;
  public catalogs: any;
  public isLoading = false;

  public startDate: string;
  public endDate: string;
  public showClean = false;

  constructor(
    private usersService: UsersService,
    private authService: AuthenticationService,
    private modalService: NgbModal,
    private toastr: ToastrService,
  ) {  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      language: {
        emptyTable: '',
        zeroRecords: 'No se encontraron usuarios',
        lengthMenu: 'Mostrar _MENU_ elementos',
        search: 'Buscar:',
        info: 'De _START_ a _END_ de _TOTAL_ elementos',
        infoEmpty: 'De 0 a 0 de 0 elementos',
        infoFiltered: '(filtrados de _MAX_ elementos totales)',
        paginate: {
          first: 'Prim.',
          last: 'Últ.',
          next: 'Sig.',
          previous: 'Ant.'
        },
      },
    };
    this.usersService
      .getUsers(this.limit, this.offset)
      .subscribe(data => {
        this.user_list = data.List;
        this.total = data.Total;
        this.dtTrigger.next();
    });
    this.catalogs = [
      'jefe-manzana',
      'user'
    ];
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.subs.forEach(sub => sub.unsubscribe());
  }

  setModalContent(content: any, userId: string): void {
    this.userId = userId;
    this.editIsSuccess = false;
    this.modalContent = content;
    this.modalService.open(this.modalContent, this.modalConfig);
  }

  public loadPage(page: number) {
    this.subs.push(
      this.usersService
        .getUsers(this.limit, page-1)
        .subscribe(data => {
          this.user_list = data.List;
          this.total = data.Total;
        })
    );
  }

  clearInputs(){

  }

  getResults(){
    this.subs.push(
      this.usersService
        .getOfficers(this.textSearch, this.limit, this.offset,"user")
        .pipe(
          catchError(err => this.authService.handleUnauthorizedError(err))
        )
        .subscribe(data => {
          this.user_list = data.List;
          this.total = data.Total;
          this.rerender();
        })
    );
  }

  rerender(): void {
    this.dtElement?.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  updateRol(){

    let data = {
      roles: this.profile,
      Area: this.area
    }
    this.subs.push(
      this.usersService.updateRole(this.userId,data)
      .pipe(
      map(() => {
        this.handleUpdateRol();
          setTimeout(() => {
            this.modalService.dismissAll();
            window.location.reload();
          }, 1500);
      }),
      )
      .subscribe()
  ); 
  }

  public deleteUser() {
    this.subs.push(
      this.usersService.deleteUser(this.userId)
        .subscribe(resolve => {
          if (resolve.active == false) {
            this.deleteIsSuccess = true;
            setTimeout(() => {
              this.modalService.dismissAll();
              window.location.reload();
            }, 2000);
          }
        })
    );
  }

  private handleUpdateRol() {
    this.isLoading = false;
    this.toastr.success('Rol editado correctamente', 'Atención ciudadana', { timeOut: 2500 });
  }

}

